const components: Record<string, any> = {
  'page': () => import('../../../packages/ui/src/page/src/index.vue'),
  'container': () => import('../../../packages/ui/src/container/src/Container.vue'),
  'button': () => import('../../../packages/ui/src/button/src/index.vue'),
  'text': () => import('../../../packages/ui/src/text/src/index.vue'),
  'img': () => import('../../../packages/ui/src/img/src/index.vue'),
  'img2': () => import('../../../packages/ui/src/img2/src/index.vue'),
  'qrcode': () => import('../../../packages/ui/src/qrcode/src/index.vue'),
  'overlay': () => import('../../../packages/ui/src/overlay/src/index.vue'),
  'text2': () => import('../../../packages/ui/src/text2/src/index.vue'),
  'turntable': () => import('../../../packages/ui/src/turntable/src/index.vue'),
};

export default components;